import { selectNewFilter } from './filtering';

export default (from_search) => {
  const prefix = (from_search) ? 'overlay-search-' : '';

  // Clear all filters
  document.addEventListener('click', async (e) => {
    const clearAll = e.target.closest(`[data-${prefix}clear-all-filters]`);
    if (!clearAll) return;

    const activeOptions = document.querySelectorAll(`[data-${prefix}filter-options] [data-clickable-option].active`);
    const manualSort = document.querySelector(`[data-${prefix}sort-by] input[value="manual"]`);
    if (activeOptions.length === 0 && manualSort && manualSort.checked === true) {
      return;
    }

    document.querySelectorAll(`[data-${prefix}filter-options] [data-clickable-option]`).forEach(el => el.classList.remove('active'));
    document.querySelectorAll(`[data-${prefix}selected-filters] [data-${prefix}selected-filters-item]`).forEach(el => el.remove());
    document.querySelectorAll(`[data-${prefix}selected-filters]`).forEach(el => el.classList.remove('active'));
    document.querySelectorAll(`[data-${prefix}clickable-option-li]`).forEach(el => el.classList.remove('active'));

    // Sorting
    document.querySelectorAll(`[data-${prefix}sort-by] input[value="manual"]`).forEach(el => el.checked = true);
    document.querySelectorAll(`[data-mobile-${prefix}filter-sorting] input[value="manual"]`).forEach(el => el.checked = true);

    await selectNewFilter();
  });

  // [ADA] Clear all filters with keyboard
  document.addEventListener('keypress', (e) => {
    const clearAll = e.target.closest(`[data-${prefix}clear-all-filters]`);
    if (!clearAll) return;
    const key = e.which || e.keyCode;
    if (key === 13 || key === 32) {
      clearAll.click();
    }
  });
  
  // Remove selected filter item
  document.addEventListener('click', async (e) => {
    const item = e.target.closest(`[data-${prefix}selected-filters-item]`);
    if (!item) return;

    const selected_value = item.getAttribute(`data-selected-filters-value`);
    const option_short_value = item.getAttribute(`data-${prefix}selected-filters-short-value`);
    const selected_type = item.getAttribute(`data-${prefix}selected-filters-type`);

    // Unselect desktop/mobile options
    document.querySelectorAll(`[data-${prefix}filter-options-type="${selected_type}"] [data-option-value="${selected_value}"]`).forEach(el => {
      el.classList.remove('active');
      if (el.parentElement) el.parentElement.classList.remove('active');
    });

    // Unselect all similar options
    document.querySelectorAll(`[data-${prefix}filter-options-type="${selected_type}"] [data-option-short-value="${option_short_value}"]`).forEach(el => {
      if (el.getAttribute('data-master-option') !== 'true') {
        el.classList.remove('active');
        if (el.parentElement) el.parentElement.classList.remove('active');
      }
    });

    // Remove the selected filter item and all related filter items
    document.querySelectorAll(`[data-${prefix}selected-filters-item][data-${prefix}selected-filters-type="${selected_type}"][data-selected-filters-value="${selected_value}"]`).forEach(el => el.remove());

    // Hide the list if no filters selected
    const selected_filters = document.querySelector(`[data-${prefix}selected-filters]`);
    if (selected_filters) {
      if (selected_filters.querySelectorAll(`[data-${prefix}selected-filters-item]`).length === 0) {
        selected_filters.classList.remove('active');
      } else {
        selected_filters.classList.add('active');
      }
    }

    await selectNewFilter();
  });

  // [ADA] Remove selected filter item with keyboard
  document.addEventListener('keypress', (e) => {
    const item = e.target.closest(`[data-${prefix}selected-filters-item]`);
    if (!item) return;
    const key = e.which || e.keyCode;
    if (key === 13 || key === 32) {
      item.click();
    }
  });
};
